export default function Location() {
  return (
    <section id="location" className="grid md:grid-cols-2">
      {/* Map */}
      <div className="h-[600px] w-full">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3154.123456789!2d145.0567!3d-37.7456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad646b5d2ba4df3%3A0x4045675218ccd90e!2s27%20Southern%20Rd%2C%20Heidelberg%20Heights%20VIC%203081!5e0!3m2!1sen!2sau!4v1234567890"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Reborn Barbershop Location Map - 27 Southern Rd, Heidelberg Heights VIC 3081"
        ></iframe>
      </div>

      {/* Info */}
      <div className="bg-zinc-900 h-[600px] flex items-center justify-center p-12">
        <div className="text-center">
          <div className="text-red-600 text-xs tracking-widest font-semibold mb-4 whitespace-nowrap">FIND US</div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-8">Visit Our Shop</h2>
          
          <address className="not-italic text-white text-2xl mb-8 leading-relaxed">
            27 Southern Rd<br />
            Heidelberg Heights VIC 3081<br />
            Australia
          </address>

          <a 
            href="https://www.google.com/maps/dir//27+Southern+Rd,+Heidelberg+Heights+VIC+3081"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border-2 border-white text-white px-8 py-4 rounded-lg text-base font-bold hover:bg-white hover:text-black transition-all mb-6 whitespace-nowrap"
          >
            <i className="ri-map-pin-line text-xl"></i>
            GET DIRECTIONS
          </a>

          <p className="text-white text-lg font-semibold mb-6 tracking-wide">
            <i className="ri-car-line mr-2"></i>Free parking available
          </p>

          <a 
            href="tel:0451279664"
            className="inline-flex items-center gap-3 text-white text-3xl font-bold hover:text-red-600 transition-colors"
          >
            <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
              <i className="ri-phone-fill text-xl"></i>
            </div>
            0451 279 664
          </a>
        </div>
      </div>
    </section>
  );
}